/* ── MIGRATION GUARD ──────────────────────────────────────────
   pre-checkout upsell funnel — would conflict with One Click Upsell while that app is live.
   Runs ONLY in preview (?br_preview=1) until you switch it on for
   real by adding 'funnel' to window.BR_LIVE. ------------------- */
(function(){
  var live = (window.BR_LIVE || []).indexOf('funnel') > -1;
  var preview = document.documentElement.classList.contains('br-preview');
  if (!live && !preview) return;   // dormant: the existing app keeps working untouched
/* ============================================================
   BR FUNNEL — native pre-checkout upsell/downsell engine (OCU-style)
   Intercepts checkout clicks, runs an offer queue with accept/decline
   branching (upsell -> downsell), then proceeds to real checkout.
   One run per session. Skips offers already accepted/declined or in cart.
   ============================================================ */
(function () {
  var cfgEl = document.getElementById('br-funnel-config');
  var root = document.getElementById('br-funnel-root');
  if (!cfgEl || !root) return;

  var offers;
  try { offers = JSON.parse(cfgEl.textContent) || []; } catch (e) { offers = []; }
  if (!offers.length) return;

  var ACCENT = root.getAttribute('data-accent') || '#B98E7A';
  var TIMER = root.getAttribute('data-timer') === 'true';
  var TIMER_MIN = parseInt(root.getAttribute('data-timer-min'), 10) || 5;
  var DONE_KEY = 'br_funnel_done';
  var SEEN_KEY = 'br_funnel_seen';   // JSON map of variantId -> 'accepted'|'declined'

  function seen() { try { return JSON.parse(sessionStorage.getItem(SEEN_KEY)) || {}; } catch (e) { return {}; } }
  function mark(id, state) { var s = seen(); s[id] = state; try { sessionStorage.setItem(SEEN_KEY, JSON.stringify(s)); } catch (e) {} }
  function money(c) {
    try { return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(c, window.Shopify.money_format || "${{amount}}") : '$' + (c / 100).toFixed(2); }
    catch (e) { return '$' + (c / 100).toFixed(2); }
  }

  // Build chains: each upsell owns the downsells that immediately follow it.
  var chains = [];
  offers.forEach(function (o) {
    if (o.type === 'upsell') chains.push({ up: o, downs: [] });
    else if (o.type === 'downsell' && chains.length) chains[chains.length - 1].downs.push(o);
  });

  var cart = null, queue = [], proceeding = false;

  function eligible(up) {
    if (!up.variantId) return false;
    var s = seen();
    if (s[up.variantId]) return false;                                  // already decided
    if (cart.items.some(function (i) { return i.variant_id === up.variantId; })) return false; // already in cart
    if (up.trigger === 'has_product') {
      return cart.items.some(function (i) { return i.product_id === up.triggerProductId; });
    }
    if (up.trigger === 'cart_min') { return cart.total_price >= (up.triggerMin || 0); }
    return cart.items.length > 0;                                       // 'always'
  }

  // ---- modal ----
  var ov = null;
  function closeModal() { if (ov) { ov.classList.remove('is-open'); var el = ov; setTimeout(function () { if (el && el.parentNode) el.parentNode.removeChild(el); }, 220); ov = null; } }

  function showOffer(offer, onAccept, onDecline) {
    closeModal();
    var price = offer.price;
    var was = offer.comparePrice && offer.comparePrice > price ? offer.comparePrice : 0;
    var pct = offer.discountPct || (was ? Math.round((1 - price / was) * 100) : 0);

    ov = document.createElement('div');
    ov.className = 'br-funnel-ov';
    ov.innerHTML =
      '<div class="br-funnel" role="dialog" aria-modal="true">' +
        '<div class="br-funnel__flag">' + (TIMER ? 'Special offer expires in <span class="br-funnel__timer">--:--</span>' : 'One-time offer') + '</div>' +
        '<div class="br-funnel__body">' +
          (offer.img ? '<img class="br-funnel__img" src="' + offer.img + '" alt="">' : '') +
          '<h3 class="br-funnel__head">' + (offer.headline || 'Add this to your order') + '</h3>' +
          (offer.sub ? '<p class="br-funnel__sub">' + offer.sub + '</p>' : '') +
          '<div class="br-funnel__price">' +
            '<span class="br-funnel__now">' + money(price) + '</span>' +
            (was ? '<span class="br-funnel__was">' + money(was) + '</span>' : '') +
            (pct ? '<span class="br-funnel__off">SAVE ' + pct + '%</span>' : '') +
          '</div>' +
          '<button class="br-funnel__accept" type="button" data-accept>' + (offer.acceptLabel || 'Yes — add it') + '</button>' +
          '<button class="br-funnel__decline" type="button" data-decline>' + (offer.declineLabel || 'No thanks') + '</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(ov);
    requestAnimationFrame(function () { ov.classList.add('is-open'); });

    // countdown
    if (TIMER) {
      var clock = ov.querySelector('.br-funnel__timer');
      var deadline = Date.now() + TIMER_MIN * 60000;
      (function tick() {
        if (!clock || !clock.isConnected) return;
        var left = Math.max(0, deadline - Date.now());
        var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
        clock.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
        if (left > 0) setTimeout(tick, 1000);
      })();
    }

    var accepted = false;
    ov.querySelector('[data-accept]').addEventListener('click', function () {
      if (accepted) return; accepted = true;
      var btn = this; btn.disabled = true; btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: offer.variantId, quantity: 1 })
      }).then(function () {
        mark(offer.variantId, 'accepted');
        if (offer.discountCode) pendingCodes.push(offer.discountCode);
        if (window.BRCart && BRCart.sectionedCart) BRCart.sectionedCart().then(BRCart.refresh);
        onAccept();
      }).catch(function () { btn.disabled = false; btn.textContent = offer.acceptLabel || 'Yes — add it'; accepted = false; });
    });
    ov.querySelector('[data-decline]').addEventListener('click', function () {
      mark(offer.variantId, 'declined');
      onDecline();
    });
  }

  var pendingCodes = [];

  // Walk a single chain: upsell, then downsell(s) on decline.
  function runChain(chain, done) {
    showOffer(chain.up, function () { done(); }, function () {
      var i = 0;
      function nextDown() {
        // find next eligible downsell in this chain
        while (i < chain.downs.length) {
          var d = chain.downs[i++]; if (!d.variantId) continue;
          var s = seen();
          if (s[d.variantId]) continue;
          if (cart.items.some(function (it) { return it.variant_id === d.variantId; })) continue;
          return showOffer(d, function () { done(); }, function () { nextDown(); });
        }
        done(); // no more downsells
      }
      nextDown();
    });
  }

  function runQueue() {
    if (!queue.length) return finish();
    var chain = queue.shift();
    runChain(chain, function () { runQueue(); });
  }

  function finish() {
    try { sessionStorage.setItem(DONE_KEY, '1'); } catch (e) {}
    closeModal();
    goCheckout();
  }

  function goCheckout() {
    if (proceeding) return; proceeding = true;
    if (pendingCodes.length) {
      // Shopify supports one code via URL; stack the rest with automatic discounts.
      window.location.href = '/discount/' + encodeURIComponent(pendingCodes[0]) + '?redirect=' + encodeURIComponent('/checkout');
    } else {
      window.location.href = '/checkout';
    }
  }

  // ---- intercept checkout clicks ----
  function isCheckoutTrigger(el) {
    return el.closest('#CartDrawer-Checkout, .cart__checkout-button, [name="checkout"], button[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
  }

  document.addEventListener('click', function (e) {
    var trg = isCheckoutTrigger(e.target); if (!trg) return;
    try { if (sessionStorage.getItem(DONE_KEY) === '1') return; } catch (x) {}
    // Only intercept once we know there are candidate offers; fetch cart synchronously-ish.
    if (proceeding) return;
    e.preventDefault(); e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      cart = c;
      queue = chains.filter(function (ch) { return eligible(ch.up); });
      if (!queue.length) { finish(); return; }   // nothing to show -> straight to checkout
      runQueue();
    }).catch(function () { finish(); });
  }, true); // capture phase so we beat the native handler

  // Close on overlay click / escape
  document.addEventListener('click', function (e) {
    if (ov && e.target === ov) { /* keep offer sticky — clicking backdrop declines current */
      var dec = ov.querySelector('[data-decline]'); if (dec) dec.click();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && ov) { var d = ov.querySelector('[data-decline]'); if (d) d.click(); } });
})();

})();
